import React, { useState, useCallback } from "react";

let _addToast = null;

export function showToast(message, type = "success") {
  if (_addToast) _addToast(message, type);
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  _addToast = useCallback((message, type = "success") => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 2800);
  }, []);

  const borderColor = (type) => {
    if (type === "success") return "border-l-[#2d9b68]";
    if (type === "warn") return "border-l-[#f47c20]";
    if (type === "error") return "border-l-[#d95353]";
    return "border-l-[#2d81c1]";
  };

  return (
    <div className="fixed right-5 bottom-5 z-[9999] flex flex-col gap-[10px]">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`min-w-[260px] max-w-[360px] bg-white border border-[#e6ecf3] border-l-4 ${borderColor(t.type)} shadow-[0_16px_30px_rgba(20,30,45,.12)] rounded-[14px] px-[14px] py-3 text-[13px] text-[#233445]`}
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
